export const MAINTENANCE = 'marketplace-maintenance-mode';
export const PRODUCTS_IN_MAINTENANCE_MODE = 'products-in-maintenance-mode';

export const availableFeatures = [MAINTENANCE, PRODUCTS_IN_MAINTENANCE_MODE];
